
import React from "react";
import { Receipt, ArrowLeft } from "lucide-react";
import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  showText?: boolean;
}

export function Logo({ 
  className, 
  size = "md", 
  showText = true 
}: LogoProps) {
  const sizes = {
    sm: "h-6",
    md: "h-8",
    lg: "h-10"
  };

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div className="relative">
        <div className="absolute inset-0 bg-primary/20 rounded-lg blur-sm"></div>
        <div className="relative flex items-center justify-center bg-gradient-to-br from-primary to-teal-500 text-white rounded-lg p-1.5">
          <div className="relative flex">
            <Receipt className={cn("text-white", sizes[size])} />
            <ArrowLeft className={cn("absolute -bottom-1 -right-1 text-amber-300", 
              size === "sm" ? "h-3" : size === "md" ? "h-4" : "h-5")} />
          </div>
        </div>
      </div>
      {showText && (
        <span className={cn("font-extrabold tracking-tight bg-gradient-to-br from-primary to-teal-500 bg-clip-text text-transparent",
          size === "sm" ? "text-lg" : size === "md" ? "text-xl" : "text-2xl"
        )}>
          SnapRefund
        </span>
      )}
    </div>
  );
}
